import React from 'react'
import styled from 'styled-components'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import VideoContainer from 'components/VideoContainer'
import { media } from 'styles/media'
import { white, borderColor } from 'styles/colors'
import { H3, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

const Inner = styled.div`
  margin: 0 auto;
  max-width: 1120px;
`

const Heading = styled(H3)`
  color: ${white};
  margin-bottom: ${spacing.small};

  ${media.medium`
    margin-bottom: ${spacing.medium};
  `};
`

const Subheading = styled(H3)`
  color: ${borderColor};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
  margin-bottom: ${spacing.large};

  ${media.medium`
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.large`
    margin-bottom: ${spacing.xxLarge};
  `};
`

const Video = () => (
  <Section>
    <Wrapper>
      <Inner>
        <Heading>Get More with Vuse+</Heading>
        <Subheading>
          Get the most out of your Vuse experience with exclusive offers, rewards, and early access to our latest
          product releases. Welcome to Vuse+
        </Subheading>
        <VideoContainer source="https://player.vimeo.com/video/415737261" />
      </Inner>
    </Wrapper>
  </Section>
)

export default Video
